// PROD-8799: the three yoga speciality categories, shared by teacher match
// (filters) and the teacher profile (view/edit). Values must stay in lockstep
// with the goserver speciality vocabulary — a teacher is tagged with these exact
// strings, and PUT /v2/teachermatch/teachers/<uuid>/specialities rejects
// anything else with a 400.
// Options are listed alphabetically (case-insensitive) for display only; the
// strings are the exact values sent to the backend, so order is cosmetic.
export const TEACHER_SPECIALITY_CATEGORIES = [
  {
    key: 'yoga_medical',
    label: 'Yoga For Medical Issues',
    options: [
      'Acid Reflux (GERD)',
      'ADHD',
      'Ankle Pain',
      'Anxiety',
      'Arthritis',
      'Asthma',
      'Cancer Recovery',
      'Cardiovascular Conditions',
      'Constipation',
      'Depression',
      'Diabetes',
      'Diastasis Recti',
      'Diet And Nutrition',
      'Digestive Issues',
      'Endometriosis',
      'Fatty Liver',
      'Fibromyalgia',
      'Frozen Shoulder',
      'High Blood Pressure',
      'High Cholesterol',
      'Hip Pain',
      'Hormonal Imbalance',
      'IBS (Irritable Bowel Syndrome)',
      'Insomnia',
      'Knee Pain',
      'Lower Back Pain',
      'Medically Referred Cases',
      'Menopause',
      'Migraine',
      'Multiple Medical Conditions',
      'Multiple Sclerosis',
      'Neck Pain',
      'Obesity',
      'Osteoporosis',
      "Parkinson's Disease",
      'PCOS/PCOD',
      'Plantar Fasciitis',
      'Post Natal',
      'Post-Surgery Recovery',
      'Prenatal',
      'Sciatica',
      'Scoliosis',
      'Shoulder Pain',
      'Sleep Apnea',
      'Stroke Recovery',
      'Thyroid Disorders',
      'Upper Back Pain'
    ]
  },
  {
    key: 'yoga_styles',
    label: 'Yoga Styles',
    options: [
      'Aerial',
      'Ashtanga',
      'Fusion',
      'Gentle',
      'Hatha',
      'Iyengar',
      'Kids',
      'Kundalini',
      'Meditation',
      'Power',
      'Pranayama Breathing',
      'Restorative',
      'Vinyasa',
      'Yin'
    ]
  },
  {
    key: 'yoga_props',
    label: 'Yoga With Props',
    options: ['Cardio', 'Chair', 'Yoga with Weights']
  }
];

export const TEACHER_SPECIALITY_KEYS = TEACHER_SPECIALITY_CATEGORIES.map(
  (category) => category.key
);

// Body shape of GET/PUT /v2/teachermatch/teachers/<uuid>/specialities: every
// category is always present, so an empty selection clears it on save.
export const emptyTeacherSpecialities = () =>
  TEACHER_SPECIALITY_KEYS.reduce((acc, key) => ({ ...acc, [key]: [] }), {});
